import { AIRPORT_CUSTOMS_LOCATION_LIST } from '@repo/constants';
import styled from 'styled-components';

type Props = {
  nationality: string;
};

export const AirportLocationGuideContent = ({ nationality }: Props) => {
  return (
    <LocationList>
      {AIRPORT_CUSTOMS_LOCATION_LIST.map(({ korLabel, label, image }) => (
        <LocationItem key={label}>
          <LocationLabel>
            {nationality === 'KOR' ? korLabel : label}
          </LocationLabel>
          <LocationImage src={image} alt='' />
        </LocationItem>
      ))}
    </LocationList>
  );
};

const LocationList = styled.ul`
  display: flex;
  flex-direction: column;
  margin-bottom: 100px;
  overflow: auto;
  padding: 20px;
`;

const LocationItem = styled.li``;

const LocationLabel = styled.h3`
  padding: 6px 0;
  background-color: #f4f4f4;
  border-radius: 4px;
  color: #111;
  font-size: 18px;
  font-weight: 600;
  line-height: 27px;
  text-align: center;
  margin-bottom: 24px;
`;

const LocationImage = styled.img`
  width: 100%;
`;
